import { configureStore } from "@reduxjs/toolkit";
import bookmarkReducer from "./slicers/bookmarks.slicer";
import homeTabReducer from "./slicers/homeTab.slicer";
import datasetsReducer from "./slicers/datasets.slicer";
import nielsenfiltersReducer from './slicers/nielsenfilters.slicer';
import eposfiltersReducer from './slicers/eposfilters.slicer';
import nielsenKpisTimeframesReducer from './slicers/nielsenfilters.slicer';

const store = configureStore({
  reducer: {
    hometab: homeTabReducer,
    datasets: datasetsReducer,
    eposfilters: eposfiltersReducer,
    nielsenfilters: nielsenfiltersReducer,
    nielsenkpistimeframes: nielsenKpisTimeframesReducer,
    bookmarks: bookmarkReducer,
  },
});

export default store;

const getStore = () => store;
const getState = () => store.getState();

export { getState, getStore };
